module.exports = __webpack_public_path__ + "static/media/logo_nouvelle_aquitaine.1d053aae.png";